import { render, staticRenderFns } from "./GrupoServico.vue?vue&type=template&id=50e34f40&scoped=true"
import script from "./GrupoServico.vue?vue&type=script&lang=js"
export * from "./GrupoServico.vue?vue&type=script&lang=js"
import style0 from "./GrupoServico.vue?vue&type=style&index=0&id=50e34f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e34f40",
  null
  
)

export default component.exports